import { ActionTypes } from '../constants/index';

export const fetchMasterCondition = () => ({
  type: ActionTypes.MASTER_CONDITION_MGMT_REQUEST,
});
